import Validate from "../pages/validate";

export default [{ path: "/validate", component: Validate }];
